import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import GreenBadge from '../../../shared/components/GreenBadge';

export default function CompanyRep(props) {
  const { profile } = props;
  const full_name = `${profile.first_name} ${profile.last_name}`
  return (
    <ListItem key={profile.id}>
      <ListItemAvatar>
        <GreenBadge overlap="circle" isOnline={true}
              anchorOrigin={{vertical: 'bottom',horizontal: 'right'}}
              variant="dot" >
        <Avatar src={profile.picture.thumb.url} alt={profile.first_name} />
            </GreenBadge>
      </ListItemAvatar>
      <ListItemText primary={full_name} secondary={profile.display_title} />
    </ListItem>
    );
}
